<template>
  <div class="flyerR">
    <v-partner data="partner"/>
    <div v-for="item in flyer" :key="item.id" :class="_class(item)" :title="item.name">
      <router-link v-if="item.local" v-bind:to="item.link">
        <v-img :src="item.image"/>
      </router-link>
      <a v-else :href="item.link" target="_blank">
        <v-img :src="item.image"/>
      </a>
    </div>
    <Match/>
  </div>
</template>

<script>
  import Match from './Match.vue'

  export default {
    name: 'FlyerR',
    props: {},
    components: {
      Match
    },
    created() {
      this.flyer = {};
      this.$root.$data.flyer.all()
        .map(f => _.set(f, "local", !_.includes(f.link, "http")))
        .filter(f => f.position === "right")
        .then(f => this.flyer = f)

    },
    methods: {
      _class(item) {
        const position = _.get(item, "position", "")
        return "box " + item.key + (position ? " " + position : "");
      }
    },
    data() {
      return {
        flyer: {}
      }
    }
  }

</script>

<style scoped lang="stylus">
  .flyerR
    a
      display flex
    .match
      @media screen and (max-width: 1200px)
        display none !important
    position absolute
    width 230px
    @media screen and (min-width: 1200px)
      right -240px
    div.right
      right -240px
    @media screen and (max-width: 1200px)
      position relative
      display none
      margin 0 auto
      div
        width: 20%;
        display inline-grid
        img
          height auto
</style>
